import {SecureService} from "@/services/superclasses/secure-service";
import {Condition} from "@/interfaces/condition";

const api = window.contextPath + '/rest/conditions';

export class ConditionSecureService extends SecureService {

    public loadAll = async (): Promise<Condition[]> => {
        return this.data(await this.get<Condition[]>(api))
    }
}

export const conditionSecureService = new ConditionSecureService()